import { Stack, SxProps, Theme } from '@mui/material';
import React from 'react';

type Props = {
  children: React.ReactNode | React.ReactNode[];
  row?: boolean;
  sx?: SxProps<Theme>;
};

export const FormControls: React.FC<Props> = ({ children, row, sx }) => (
  <Stack spacing={4} direction={row ? 'row' : 'column'} sx={sx}>
    {children}
  </Stack>
);
